import React, { useState } from 'react';
import logo1 from "../../img/logo1.png"
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { makeStyles } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';
import Menu from "./Menu";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { IconButton, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import MenuDrawer from './MenuDrawer';
import Slide from '@material-ui/core/Slide';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import Searchbar from './Searchbar';
import { toast } from 'react-toastify';
const useStyles = makeStyles((theme) => ({

    container: {
        width: "100%",

        backgroundColor: "white",
        flexGrow: 1,

        //   justifyContent: "space-between",

    },

    root: {
        fontSize: "25px",
        color: "black",
        fontWeight: 550,

        "&:hover": {
            color: theme.palette.primary.main
        },
        "@media (max-width: 770px)": {
            display: "none"
        }
    },
    imgroot: {
        marginRight: "10%",
        marginLeft: "50px",
        "@media (max-width: 770px)": {
            width: "70px",
            margin: "5px",


        }
    },
    menuicon: {

        "@media (min-width: 770px)": {
            display: "none",

        }
    },

    title: {
        flexGrow: 1,
        color: "white"
    },

    Drawer: {
        "@media (min-width:770px)": {
            display: "none"
        }
    },


}));

function HideOnScroll(props) {
    const { children, window } = props;
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({ target: window ? window() : undefined });

    return (
        <Slide appear={false} direction="down" in={!trigger}>
            {children}
        </Slide>
    );
}

const Header = () => {

    const style = useStyles();

    const [value, setValue] = useState(1);

    const handleChange = (event, newValue) => {
        console.log(newValue);
        if (newValue === 2) {
            toast('🎁✨ 교환 페이지는 아직 준비 중입니다!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            return
        }
        setValue(newValue);
    };

    const [open, setOpen] = useState(false);

    const handleDrawer = () => {
        setOpen(!open);
    }




    return (
        <>
            {/* <div className={style.container}> */}
            {/* <HideOnScroll> */}
            <AppBar color="inherit"
                position="static"
            >
                <Toolbar>
                    <Tabs value={value} indicatorColor="primary" textColor="primary" onChange={handleChange}>
                        <img className={style.imgroot} src={logo1} alt="surbay" />
                        <Tab className={style.root} label="품앗이" />
                        <Tab className={style.root} label="교환" />
                    </Tabs>
                    <Typography className={style.title}>
                        SurBay
                    </Typography>
                    <Searchbar />
                    <IconButton className={style.menuicon} onClick={handleDrawer}>
                        {open ? <CloseIcon fontSize="large" color="secondary" /> : <MenuIcon fontSize="large" />}
                    </IconButton>

                </Toolbar>
                <Menu />
            </AppBar>
            {/* </HideOnScroll> */}
            {/* </div> */}
            <div className={style.Drawer}>
                {open ? <MenuDrawer /> : null}
            </div>
        </>

    );
};

export default Header;